var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center details"},[(_vm.skuNumber)?_c('div',[_vm._v(" "+_vm._s(_vm.$t("orders.sku"))+": "+_vm._s(_vm.skuNumber)+" ")]):_c('div',[_c('span',{staticClass:"text-dashed"},[_vm._v("-")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }